/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'
import {useIntl} from 'react-intl'
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Box,
    Heading
} from '@salesforce/retail-react-app/app/components/shared/ui'
import CustomAccordionIcon from '../../../components/customAccordionIcon'
import pdpAccordionStyles from '../../../theme/components/project/pdp-accordion'

const InformationAccordion = ({shippingDelayReturnsContent}) => {
    const {formatMessage} = useIntl()
    const [isHydrated, setIsHydrated] = useState(false)
    useEffect(() => {
        setIsHydrated(true)
    }, [])

    return (
        <Accordion defaultIndex={[0]} allowMultiple>
            {/* Shipping Delays & Returns */}
            <AccordionItem mt={8} borderBottom={'none'} borderColor={'#DADADA'}>
                {({isExpanded}) => (
                    <>
                        <AccordionButton padding={0} mt={8}>
                            <Heading
                                as={'h2'}
                                flex="1"
                                textAlign="left"
                                fontWeight="extrabold"
                                fontSize={{base: '2xl', md: 'fontSize32'}}
                                lineHeight={{base: '8', md: '10'}}
                            >
                                {formatMessage({
                                    defaultMessage: 'Shipping & Returns',
                                    id: 'product_shipping_delays_returns.accordion'
                                })}
                            </Heading>
                            <CustomAccordionIcon isExpanded={isExpanded} />
                        </AccordionButton>
                        <AccordionPanel padding={0} mt={6}>
                            {isHydrated && (
                                <Box
                                    sx={{
                                        ...pdpAccordionStyles
                                    }}
                                >
                                    {shippingDelayReturnsContent &&
                                        parse(shippingDelayReturnsContent)}
                                </Box>
                            )}
                        </AccordionPanel>
                    </>
                )}
            </AccordionItem>
        </Accordion>
    )
}

InformationAccordion.propTypes = {
    product: PropTypes.object,
    shippingDelayReturnsContent: PropTypes.string
}

export default InformationAccordion
